import {DataLoader} from '@wallaby-ui/core';
import React from 'react';

import {useLoadMedicationAtcs} from '../hooks';

interface OwnProps extends DataLoader {}
type Props = OwnProps;

export const MedicationsLoader: React.FC<Props> = (props) => {
  const {apiUrl, children} = props;

  const {isLoading, error} = useLoadMedicationAtcs(apiUrl);

  return isLoading || error ? null : <>{children}</>;
};

MedicationsLoader.displayName = 'MedicationsLoader';
